module.exports = __webpack_public_path__ + "media/icons/badanie-techniczne-9e377b0a.png";